module.exports = __webpack_public_path__ + "static/feature-showcase-browser-89355ef99806d9f83a789939c3f0a482.svg";